// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vTitle[data-v-797a1871] {\n  background-image: -webkit-linear-gradient(top, #fff, #a1c7e8, #7bbef6);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-size: 0.09rem;\n  line-height: 0.15rem;\n  font-weight: 600;\n  padding-left: 0.1rem;\n}\n.flex[data-v-797a1871] {\n  align-items: center;\n}\n.titleI[data-v-797a1871] {\n  height: 50%;\n  margin-left: 0.1rem;\n}\n", ""]);
// Exports
module.exports = exports;
